const integrators = [
  {
    pos: "POS Bottle",
    id: "240208002",
  },
];

export default integrators;
